import { Model } from '@/models/Model';
export class Activity extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Activity';
        this.$endpoint = '/activities';
        this.$fillable = ['users', 'room', 'areas', 'topics', 'levels', 'groups', 'timeslots', 'type'];
    }
}
